export async function downloadFromUrl(
  url: string,
  options?: {
    filename?: string;
  },
) {
  const response = await $fetch.raw(url);
  const blob = (await response._data) as Blob;

  downloadFromBlob(blob, options);
}

export function downloadFromBlob(
  blob: Blob,
  options?: {
    filename?: string;
  },
) {
  const aElement = document.createElement("a");
  aElement.setAttribute("download", options?.filename ?? "file");
  const href = URL.createObjectURL(blob);
  aElement.href = href;
  aElement.setAttribute("target", "_blank");
  aElement.click();
  URL.revokeObjectURL(href);
  aElement.remove();
}
